import {useMemo} from 'react';
import type {Schema} from 'schemaDefinition/types';
import {
  schemaRefCorporation,
  schemaRefEvent,
  schemaRefPerson,
  schemaRefPublisher,
} from 'schemas/types';
import {useSchema} from './useSchema';

export const useAgentSchemas = (): [
  person: Schema,
  corporation: Schema,
  publisher: Schema,
  event: Schema,
] => {
  // const agentTypes = useMemo((): AgentType[] => [Concept.person], []);
  const personAgentSchema = useSchema(schemaRefPerson);
  const coprporationAgentSchema = useSchema(schemaRefCorporation);
  const publisherAgentSchema = useSchema(schemaRefPublisher);
  const eventAgentSchema = useSchema(schemaRefEvent);
  return useMemo(
    () => [
      personAgentSchema,
      coprporationAgentSchema,
      publisherAgentSchema,
      eventAgentSchema,
    ],
    [
      personAgentSchema,
      coprporationAgentSchema,
      publisherAgentSchema,
      eventAgentSchema,
    ],
  );
};
